import { createSlice } from "@reduxjs/toolkit";
import { AssignTaskList } from "./thunk";

interface AssignTaskListTaskState {
  tasksAssignList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: AssignTaskListTaskState = {
  tasksAssignList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const AssignTaskSlice = createSlice({
  name: "assignTask",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AssignTaskList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AssignTaskList.fulfilled, (state, action) => {
        state.loading = false;
        state.tasksAssignList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(AssignTaskList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch task list";
      });
  },
});

export default AssignTaskSlice.reducer;
